import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface ForcePasswordRouteProps {
  children: React.ReactNode
}

/**
 * Route guard for force password change page.
 * - Requires authentication
 * - Redirects to dashboard if password change is not required
 * - Does NOT redirect away if forcePasswordChange is true (unlike ProtectedRoute)
 */
export function ForcePasswordRoute({ children }: ForcePasswordRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Allow access if authenticated
  // (user might want to voluntarily change their password)
  return <>{children}</>
}
